import { __awaiter } from '../../_virtual/_tslib.js';
import React__default, { useState } from 'react';
import classNames from 'classnames';
import Styles from './UploadFileInput.module.scss.js';
import Row from '../grid/row/Row.js';
import Col from '../grid/col/Col.js';
import 'reactstrap/lib/Container';
import { toast } from '../toast/toast.js';
import AvatarImage from '../avatar-image/AvatarImage.js';

const UploadFileInput = ({ setProfilePic, savedProfile, classMain, labelText }) => {
    const [viewProfilePic, setViewProfilePic] = useState(null);
    const onSelectFile = (e) => __awaiter(void 0, void 0, void 0, function* () {
        const allowedExtensions = ["jpg", "png", "jpeg", "JPG", "PNG", "JPEG"];
        const sizeLimit = 10000000;
        const fileExtension = e.target.files[0].name.split(".").pop();
        if (!allowedExtensions.includes(fileExtension)) {
            toast.error("Please select the right format! (.jpg, .jpeg, .png)");
            return;
        }
        else if (e.target.files[0].size > sizeLimit) {
            toast.error("File size too large");
            return;
        }
        setProfilePic(e.target.files[0]);
        const fileReader = new FileReader();
        fileReader.readAsDataURL(e.target.files[0]);
        fileReader.onload = () => {
            setViewProfilePic(fileReader.result);
        };
    });
    return (React__default.createElement("div", { className: classNames(Styles.uploadNewPictureWrap, classMain) },
        React__default.createElement(Row, { className: Styles.row, noGutters: true },
            React__default.createElement(Col, { className: Styles.picViewCol },
                React__default.createElement("div", { className: Styles.picView },
                    React__default.createElement(AvatarImage, { imageUrl: viewProfilePic || savedProfile }))),
            React__default.createElement(Col, { className: Styles.uploadPicCol },
                React__default.createElement("input", { type: "file", name: "profilePicture", id: "upload-photo", onChange: onSelectFile, hidden: true, accept: ".jpg, .png, .jpeg" }),
                React__default.createElement("label", { htmlFor: "upload-photo", className: Styles.uploadPhoto }, labelText)))));
};

export { UploadFileInput as default };
//# sourceMappingURL=UploadFileInput.js.map
